<div class="menu-navegacao-container-aba-leis">
  <div
    class="menu-button menu-button-aba-leis"
    mat-button
    type="button"
    cdkOverlayOrigin
    #abasOverlay="cdkOverlayOrigin"
    #abasViewOverlay
    (click)="overlayOpen()"
  >
    <mat-icon
      class="navegacao-menu-button-icon"
      [svgIcon]="isOverlayOpen ? 'chevron-up' : 'chevron-down'"
    ></mat-icon>
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="abasOverlay"
  [cdkConnectedOverlayOpen]="isOverlayOpen"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayHasBackdrop]="true"
  (detach)="isOverlayOpen = false"
  (backdropClick)="overlayOpen()"
  [cdkConnectedOverlayPanelClass]="'navegacao-leis-abas-Overlay-custom'"
>
  <div class="navegacao-leis-abas-custom">
    <div
      class="navegacao-leis-abas-search"
      type="button"
      cdkOverlayOrigin
      #searchOverlay="cdkOverlayOrigin"
      #serchViewOverlay
      [ngClass]="{ opened: isOverlayOpen }"
    >
      <button mat-icon-button [disableRipple]="true" aria-label="Pesquisar">
        <mat-icon
          svgIcon="search"
          class="material-icons-outlined navegacao-leis-abas-icon-search"
        ></mat-icon>
      </button>
      <label class="navegacao-leis-abas-label">Pesquisa por abas</label>
      <input
        placeholder="Pesquisar abas"
        class="navegacao-leis-abas-input"
        [(ngModel)]="searchText"
        (ngModelChange)="searchTextChange()"
      />
      <!-- [formControl]="searchControl" -->
      <button
        *ngIf="searchText?.length > 0"
        mat-icon-button
        mat-button
        (click)="searchTextClear()"
      >
        <mat-icon
          svgIcon="xmark-circle"
          class="material-symbols-outlined navegacao-leis-abas-icon-clear"
        ></mat-icon>
      </button>
    </div>

    <mat-divider class="navegacao-leis-abas-divider"></mat-divider>

    <span class="navegacao-leis-abas-label">
      <p class="navegacao-leis-abas-paragraph">Resultados encotrados</p>
    </span>

    <ng-container *ngIf="(filteredSearch$ | async)?.length > 0; else Empty">
      <cdk-virtual-scroll-viewport
        itemSize="10"
        minBufferPx="200"
        maxBufferPx="400"
        class="navegacao-abas-virtual-scroll-viewport"
      >
        <app-item-navegacao-aba-leis
          *cdkVirtualFor="let item of filteredSearch$ | async"
          [item]="item"
          class="navegacao-abas-virtual-scroll-item"
          (selecionarAbaLei)="alternarPara($event)"
          (fecharAbaLei)="fecharGuia($event)"
        >
        </app-item-navegacao-aba-leis>
      </cdk-virtual-scroll-viewport>
    </ng-container>
  </div>
</ng-template>

<ng-template #Empty></ng-template>
